<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="flex flex-col w-full justify-center">
            <team-user-target-access
                :teamId="props.teamId"
                :userId="props.userId"
                :isKiosk="true"
                :isAdminOrOwner="true"
                :requireSso="team.require_sso"
            />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import TeamUserTargetAccess from '~/components/settings/teams/membership/form/TeamUserTargetAccess.vue';
import { useTeamDetails } from '../composables/useTeamDetails';

const props = defineProps<{
    teamId: number;
    userId: number;
}>();

const { team } = useTeamDetails();
</script>
